import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { filter, from, mergeMap, Subject, takeUntil } from "rxjs";

@Component({
    selector: "payment-validated",
    templateUrl: "./payment-validated.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PaymentValidatedComponent implements OnInit, OnDestroy {

    constructor(private route: ActivatedRoute, private router: Router) { }

    private _destroy$ = new Subject<void>();

    ngOnInit() {

        this.route.params
            .pipe(
                filter(params => !params['teamId']),
                mergeMap(params => {
                    return this.router.navigate(['/login']);
                }),
                takeUntil(this._destroy$)
            ).subscribe();

    }

    ngOnDestroy(): void {
        this._destroy$.next();
        this._destroy$.complete();
    }
}